import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SerializeModuleService } from '../edit/serialize-module.service';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ModulesSaveResultEnum } from './models/modules-save-result.enum';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../edit/serialize-module.service";
// #NOTE: [EM] This assumes services on qa and scene-editor
// #TODO: [EM] Make this service API explicit about qa vs production
var cdbURL = 'cdb/content';
var cdbCopyURL = "cdb/copy/content";
var formHeaders = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
    })
};
// top-level directories we wish to expose to content creators directly
var primaryCategories = [
    'production',
    'client',
    'preview',
    'internal_content',
    'public_preview',
    'demos',
    'social'
];
var ModulesService = /** @class */ (function () {
    function ModulesService(http, serializeModuleService) {
        this.http = http;
        this.serializeModuleService = serializeModuleService;
    }
    // write the story module to the modules server
    ModulesService.prototype.saveModule = function (story, modulePath) {
        modulePath = this.formatModulePath(modulePath);
        var url = [cdbURL, 'modules', modulePath].join('/');
        // !important: custom stringify, escape non-ASCII unicode sequences
        var storyJSONString = this.JSONStringify(story);
        return this.http.put(url, storyJSONString, formHeaders).pipe(
        // success    
        map(function () { return ModulesSaveResultEnum.Success; }), 
        // http status 201 | 202 treated as "error" by Angular HTTP, handle server response
        catchError(function (_a) {
            var status = _a.status;
            if (status >= 200 && status <= 202) {
                return of(ModulesSaveResultEnum.Success);
            }
            else {
                return of(ModulesSaveResultEnum.Fail);
            }
        }));
    };
    // Post a request to make a hard copy of content state directory
    ModulesService.prototype.copyState = function (sourceId, targetId) {
        var url = [cdbCopyURL, "states", targetId].join('/');
        var options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json; charset=utf-8',
                'source-state': sourceId
            })
        };
        return this.http.put(url, {}, options);
    };
    ModulesService.prototype.listContents = function (primaryCategory, secondaryCategory, name) {
        var path = this.generateModulePath(primaryCategory, secondaryCategory || '', name || '');
        return this.http.get("/cdb/ls/content/modules/" + path)
            .pipe(map(function (results) {
            return results.contents;
        }));
    };
    ModulesService.prototype.getState = function (id) {
        return this.http.get("/cdb/ls/content/states/" + id)
            .pipe(map(function (results) {
            return results.contents;
        }));
    };
    // return list of BioDigital Client directories
    ModulesService.prototype.getClients = function () {
        return this.http.get("/search/client")
            .pipe(map(function (response) {
            return response.clients;
        }));
    };
    // Iterates through an entire scene and determine what states are in use by all the assets.
    // A very thorough check resulting in quite a limited output.
    ModulesService.prototype.getUsedStates = function () {
        var _this = this;
        var states = {};
        Object.values(Human.scene.objects)
            .reduce(function (result, object) {
            ['transformId', 'morphId', 'geometryId', 'materialId'].forEach(function (property) {
                var state = _this.getPropertyState(object, property);
                if (state.length) {
                    states[state] = true;
                }
            });
            if (object.hasOwnProperty('renderables')) {
                ['morphId', 'geometryId', 'materialId'].forEach(function (property) {
                    var renderables = object.renderables;
                    renderables.forEach(function (renderable) {
                        var state = _this.getPropertyState(renderable, property);
                        if (state.length) {
                            states[state] = true;
                        }
                    });
                });
            }
            return result;
        }, {});
        return Object.keys(states);
    };
    // Get the semantically meaningful parts of a module path
    ModulesService.prototype.parseScenePath = function (id) {
        var parts = id.split('/');
        if (parts.length === 1) {
            // invalid scene path
            return null;
        }
        // # NOTE: [EM] hardcoded content environment
        var urlSubDomain = "qa" /* qa */;
        return {
            fullPath: "https://" + urlSubDomain + ".biodigital.com/content/modules/" + id,
            relativePath: parts.slice(0, parts.length - 1).join('/'),
            sceneName: parts[parts.length - 1]
        };
    };
    // ensure the moduleId has a .json extension
    ModulesService.prototype.formatModulePath = function (modulePath) {
        var result = modulePath;
        if (!/\.json$/.test(modulePath)) {
            result = result + ".json";
        }
        return result;
    };
    // Return a list of primary modules categories
    ModulesService.prototype.getPrimaryCategories = function () {
        return of(primaryCategories);
    };
    // Return a list of secondary catogories, given a primary category
    ModulesService.prototype.getSecondaryCategories = function (primaryCategory) {
        switch (primaryCategory) {
            case 'production': {
                // list gender categories
                return of(['maleAdult', 'femaleAdult']);
            }
            case 'client': {
                // list client-projects
                return this.getClients();
            }
            default: {
                // no secondary category available
                return of([]);
            }
        }
    };
    ModulesService.prototype.generateSaveModule = function (id) {
        var scenePath = this.parseScenePath(id);
        var categories = scenePath.relativePath.split('/');
        return {
            id: id,
            name: scenePath.sceneName,
            primaryCategory: categories[0] || '',
            secondaryCategory: categories[1] || ''
        };
    };
    ModulesService.prototype.generateModulePath = function (primaryCategory, secondaryCategory, name) {
        var path = [];
        if (primaryCategory.length) {
            path.push(primaryCategory);
        }
        if (secondaryCategory.length) {
            path.push(secondaryCategory);
        }
        if (name.length) {
            if (name.indexOf('.json') < 0) {
                name = name + ".json";
            }
            path.push(name);
        }
        return path.join('/');
    };
    ModulesService.prototype.getPropertyState = function (object, property) {
        if (object[property] != null) {
            return object[property].split('/')[0];
        }
        return '';
    };
    // #TODO: centralize/reuse
    ModulesService.prototype.JSONStringify = function (object) {
        return JSON.stringify(object)
            .replace(/[\u007f-\uffff]/g, function (character) {
            return '\\u' + ('0000' + character.charCodeAt(0).toString(16)).slice(-4);
        });
    };
    ModulesService.ngInjectableDef = i0.defineInjectable({ factory: function ModulesService_Factory() { return new ModulesService(i0.inject(i1.HttpClient), i0.inject(i2.SerializeModuleService)); }, token: ModulesService, providedIn: "root" });
    return ModulesService;
}());
export { ModulesService };
